import React from "react";

const SelectArrow = () => (
  <svg
    width="14"
    height="7"
    viewBox="0 0 14 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.705566 1.59275L6.99979 6.98779L13.1996 1.67363L12.1983 0.556297L6.99979 5.01218L1.69356 0.463985L0.705566 1.59275Z"
      fill="black"
    />
  </svg>
);

export default SelectArrow;
